import { render, staticRenderFns } from "./DialogNotes.vue?vue&type=template&id=e2bb9a84&"
import script from "./DialogNotes.vue?vue&type=script&lang=js&"
export * from "./DialogNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports